// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckoutErrorModals__wrapper___1sYZO","paragraph":"CheckoutErrorModals__paragraph___2Oso9"};